import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { ConfirmEventType, ConfirmationService, Message } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MsPermissionService } from 'src/app/services/ms-permission.service';


@Component({
  selector: 'app-ms-criteria',
  templateUrl: './ms-criteria.component.html',
  styleUrls: ['./ms-criteria.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class MsCriteriaComponent {

  header: string = this.translate("Criterias");
  criteriaForm: FormGroup = new FormGroup({
    channel: new FormControl('', Validators.required),
    criteria: new FormControl('', Validators.required),
  })
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/assign-weights/',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Criterias'), link: '/ms/criterias' },
  ];

  measuringTypes: any[] = [{ label: this.translate("Rating"), value: this.translate("Rating") }, { label: this.translate("Yes, No"), value: this.translate("Yes, No") }, { label: this.translate("True, False"), value: this.translate("True, False") }]

  stepCriteria: number = 1;
  isInternalPM: boolean = false;
  projectId: string = '';
  skelition: boolean = true;
  criterias: any[] = [];
  totalCriterias: number = 0;
  criteriaEditIndex: number = -1;
  session: any;
  tableCount: number = 0;


  //Notificaitons
  messages: Message[] = [];
  project: any;
  channels: any[] = [];
  basicChannels: any;
  selectedBranches: any;
  sub_criteria: {
    "projectId"?: string;
    "criteriaId"?: string;
    "criteria"?: string;
    "approvalStatus"?: string;
    "comments"?: string;
  } = {};

  factor: {
    "projectId"?: string,
    "subCriteriaId"?: string,
    "factor"?: string,
    "measuringType"?: string,
    "approvalStatus"?: string,
    "reason"?: string,
    "repeat"?: 0,
    "comments"?: string,
    "forwardedTo"?: string,
    "status"?: string
  } = {}
  sub_criterias: any;
  pmComment: string = '';
  stepStatus: any = [];
  statusType: string = '';
  hasStatusDB: boolean = true;

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      this.links[0].link = '/ms/assign-weights/' + this.projectId;
      if (this.projectId) {
        Promise.all([
          this.getProject(this.projectId).then(() => {

            let pm = MsPermissionService.checkUserPermissions(this.project);
            if (pm == true) {
              this.isInternalPM = true;
            } else if (pm == false) {
              this.router.navigate(['/ms/project'])
              return;
            }

            this.getStepStatus()
          }),
          this.getCriterias(),
        ]).then(() => { this.skelition = false })
      }
    })
  }

  increseCount() {
    this.tableCount = this.tableCount + 1;
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getCriterias() {
    try {
      let res = await this.dataService.getData(`ms-criteria/project/${this.projectId}/1/1000`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.criterias = res.data.data;
      console.log('CRITERIAS', this.criterias);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async createCriteria() {
    this.messages = [];
    if (this.criteriaForm.valid) {
      try {
        this.skelition = true;
        console.log(this.criteriaForm.value)
        let data = this.criteriaForm.value;
        data['projectId'] = this.projectId;
        let res = await this.dataService.postData(`ms-criteria`, data)
        if (res.error) {
          console.log(res.error);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ]
          return;
        }
        this.criteriaForm.reset()
        this.getCriterias();
        this.getStepStatus();
        this.skelition = false;
      } catch (e: any) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: e.toString() },
        ]
      }
    }
  }

  getCriteriaNames(criterias: any[]) {
    return criterias.map(c => c.criteria).join(', ')
  }

  async updateCriteria(criteria: any) {
    this.messages = [];
    try {
      this.skelition = true;
      criteria.channel = criteria.channel._id;
      let res = await this.dataService.postData(`ms-criteria`, criteria, 'PUT')
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.criteriaEditIndex = -1;
      this.getCriterias();
      this.getStepStatus();
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  confirmDelete(id: string) {
    this.messages = [];
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => {
        this.deleteCriteria(id);
      },
    });
  }

  async deleteCriteria(id: string) {
    this.messages = [];
    try {
      this.skelition = true;
      let res = await this.dataService.deleteData(`ms-criteria/${id}`)
      if (res.error) {
        this.skelition = false;
        console.log(res.error);
        return;
      }
      this.getCriterias();
      this.skelition = false;
    } catch (e) {
      console.log(e);
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  trackByIndex(index: number, item: any) {
    return index;
  }

  getIterationNumber(index: number): number {
    let currentMain = '';
    let currentSub = '';
    let iteration = 1;

    for (let i = 0; i < index; i++) {
      if (this.criterias[i].main !== currentMain || this.criterias[i].sub !== currentSub) {
        currentMain = this.criterias[i].main;
        currentSub = this.criterias[i].sub;
        iteration++;
      }
    }

    return iteration;
  }

  async postSubCriteriaAndFactor() {
    this.messages = [];
    if (this.sub_criteria.criteriaId && this.sub_criteria.criteria) {
      try {
        this.skelition = true;

        this.sub_criteria.projectId = this.projectId;

        let res = await this.dataService.postData(`ms-sub-criteria`, this.sub_criteria)
        if (res.error) {
          this.skelition = false;
          console.log(res.error);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ]
          return;
        }

        if (this.factor.factor && this.factor.measuringType) {

          this.factor.projectId = this.projectId;
          this.factor.subCriteriaId = res.data._id;

          res = await this.dataService.postData(`ms-factors`, this.factor)
          if (res.error) {
            console.log(res.error);
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ]
            return;
          }
        }
        this.factor = {};
        this.ngOnInit();
      } catch (e: any) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: e.toString() },
        ]
      }
    }
  }

  getRowIndex(criteriaIndex: number, subCriteriaIndex: number, factorIndex?: number): number {
    let index = 0;
    for (let i = 0; i < criteriaIndex; i++) {
      index += this.criterias[i]['sub-criterias'].length || 1;
    }
    index += subCriteriaIndex + 1;
    if (factorIndex !== undefined) {
      index += factorIndex + 1;
    }
    else {
      index += 1;
    }
    return index - 1;
  }


  async getSession() {
    try {
      let res = await this.dataService.getData(`ms-sessions/calender/` + this.projectId);
      if (res.error) return;
      this.session = res.data;
      console.log('SESSION', this.session);
    } catch (error) {
      console.log(error)
    }
  }

  async getStepStatus() {
    this.skelition = true;
    try {
      let vendorType = (this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) ? 'internal' : 'external';
      let res = await this.dataService.getData('ms-step/project/' + this.projectId + '/Criteria/' + vendorType);
      if (res.error) {
        this.hasStatusDB = false;
        return
      }
      this.stepStatus = res.data;

      if (this.stepStatus) {
        this.statusType = this.stepStatus.approvalStatus;
        if (this.statusType == 'Redo' || this.statusType == 'Change') {
          this.pmComment = this.stepStatus.comments;
        }
      }

      console.log("this.statusType", this.statusType);

      this.skelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  approveStatus() {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Approved',
            comments: this.pmComment,
            step: 'Criteria',
            doneBy: localStorage.getItem('uid'),
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  redoStatus() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Redo',
            comments: this.pmComment,
            step: 'Criteria',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  async pendingStatus() {
    try {
      let approveData: any = {
        projectId: this.projectId,
        approvalStatus: 'Pending',
        comments: this.pmComment,
        step: 'Criteria',
        doneBy: localStorage.getItem('uid'),
      };
      this.skelition = true;
      let res = await this.dataService.postData('ms-step', approveData);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  submitForApproval() {
    if (this.criterias.length > 0) {
      this.confirm({
        message: this.translate('Are you sure you want to do this?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          this.pendingStatus();
        },
      });
    }
    else {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: "" },
      ];
      return;
    }
  }

  requestChange() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Change',
            comments: this.pmComment,
            step: 'Criteria',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }
}
